/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import * as Types from '../../../graphql.generated'

const defaultOptions = {} as const
export type GetPatientCredentialingHealthPlanQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
}>

export type GetPatientCredentialingHealthPlanQuery = {
  __typename?: 'Query'
  patient: { __typename?: 'Patient'; credentialingHealthPlan?: string | null }
}

export const GetPatientCredentialingHealthPlanDocument = gql`
  query getPatientCredentialingHealthPlan($uid: ID!) {
    patient(uid: $uid) {
      credentialingHealthPlan
    }
  }
`

/**
 * __useGetPatientCredentialingHealthPlanQuery__
 *
 * To run a query within a React component, call `useGetPatientCredentialingHealthPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientCredentialingHealthPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientCredentialingHealthPlanQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetPatientCredentialingHealthPlanQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPatientCredentialingHealthPlanQuery,
    GetPatientCredentialingHealthPlanQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetPatientCredentialingHealthPlanQuery, GetPatientCredentialingHealthPlanQueryVariables>(
    GetPatientCredentialingHealthPlanDocument,
    options
  )
}
export function useGetPatientCredentialingHealthPlanLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPatientCredentialingHealthPlanQuery,
    GetPatientCredentialingHealthPlanQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetPatientCredentialingHealthPlanQuery, GetPatientCredentialingHealthPlanQueryVariables>(
    GetPatientCredentialingHealthPlanDocument,
    options
  )
}
export type GetPatientCredentialingHealthPlanQueryHookResult = ReturnType<
  typeof useGetPatientCredentialingHealthPlanQuery
>
export type GetPatientCredentialingHealthPlanLazyQueryHookResult = ReturnType<
  typeof useGetPatientCredentialingHealthPlanLazyQuery
>
export type GetPatientCredentialingHealthPlanQueryResult = Apollo.QueryResult<
  GetPatientCredentialingHealthPlanQuery,
  GetPatientCredentialingHealthPlanQueryVariables
>
